export function jsonToForm(json) {
  return json;
}

export function formToJson(json) {
  const newJson = JSON.parse(JSON.stringify(json));
  return newJson;
}